import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Step,
    StepLabel,
    Stepper,
    TextField,
    Typography,
} from "@vapor/react-material";
import { DatePicker } from "@vapor/react-x-date-pickers";
import { FormattedMessage, useIntl } from "react-intl";
import { AttoTrasferimentoAzienda } from "../../../../../interfaces/products";
import "./style.scss";

interface IAttoTrasferimentiModal {
    activeStep: any;
    setActiveStep: (val: any) => void;
    startDate: any;
    endDate: any;
    setEndDate: (val: any) => void;
    kDoc: any;
    setKDoc: (val: any) => void;
    listaAtti: Array<AttoTrasferimentoAzienda>;
}

const AttoTrasferimentiModal = ({
    activeStep,
    setActiveStep,
    startDate,
    endDate,
    setEndDate,
    kDoc,
    setKDoc,
    listaAtti,
}: IAttoTrasferimentiModal) => {
    const intl = useIntl();
    return (
        <div className="bis-modals-buyProduct-transfer-root">
            <div
                className={
                    "bis-modals-buyProduct-transfer-stepper" +
                    (activeStep === 1 ? " step1" : "")
                }
            >
                <Stepper activeStep={activeStep} alternativeLabel>
                    <Step>
                        <StepLabel>
                            <FormattedMessage id="modals.buy.transfer.step1" />
                        </StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>
                            <FormattedMessage id="modals.buy.transfer.step2" />
                        </StepLabel>
                    </Step>
                </Stepper>
            </div>
            {activeStep === 0 && (
                <div className="bis-modals-buyProduct-transfer-content">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className="bis-modals-buyProduct-content-text">
                                <FormattedMessage id="modals.buy.transferDescription1" />
                            </div>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            display={"flex"}
                            justifyContent={"space-between"}
                        >
                            <DatePicker
                                disabled
                                label={intl.formatMessage({
                                    id: "modals.buy.transfer.startDate",
                                })}
                                value={startDate}
                                onChange={(val: any) => {}}
                                renderInput={(params: any) => (
                                    <TextField
                                        {...params}
                                        helperText={null}
                                        error={false}
                                        style={{ width: 200 }}
                                    />
                                )}
                            />
                            <DatePicker
                                label={intl.formatMessage({
                                    id: "modals.buy.transfer.endDate",
                                })}
                                value={endDate}
                                onChange={(val: any) => setEndDate?.(val)}
                                renderInput={(params: any) => (
                                    <TextField
                                        {...params}
                                        helperText={null}
                                        error={false}
                                        style={{ width: 200 }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <div className="bis-modals-buyProduct-content-text">
                                <FormattedMessage id="modals.buy.transferDescription2" />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            )}
            {activeStep === 1 && (
                <div className="bis-modals-buyProduct-content">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel id="bis-modals-buyProduct-bilancio-year-label">
                                    <FormattedMessage id="modals.buy.transfer.kdoc" />
                                </InputLabel>
                                {listaAtti?.length === 0 ? (
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontStyle: "italic",
                                            color: "text.secondary",
                                        }}
                                    >
                                        Non sono presenti documenti nel range temporale selezionato
                                    </Typography>
                                ) : (
                                    <Select
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 242,
                                                },
                                            },
                                        }}
                                        value={kDoc}
                                        onChange={(e) =>
                                            setKDoc(e.target.value)
                                        }
                                    >
                                        {listaAtti?.map(
                                            (
                                                atto: AttoTrasferimentoAzienda,
                                            ) => {
                                                return (
                                                    <MenuItem
                                                        key={
                                                            "atto_kdoc_" +
                                                            atto.kdoc
                                                        }
                                                        value={atto.kdoc}
                                                    >
                                                        {
                                                            atto.descrizione_codice_atto
                                                        }{" "}
                                                        ({atto.data_documento})
                                                    </MenuItem>
                                                );
                                            },
                                        )}
                                    </Select>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="bis-modals-buyProduct-content-text">
                                <FormattedMessage id="modals.buy.buying" />:
                            </div>
                            <div className="bis-modals-buyProduct-content-product">
                                {"ATTO TRASFERIMENTO AZIENDA"}{" "}
                                {kDoc &&
                                    `(${
                                        listaAtti?.find(
                                            (atto: AttoTrasferimentoAzienda) =>
                                                atto?.kdoc === kDoc,
                                        )?.data_documento
                                    })`}
                            </div>
                            <div className="bis-modals-buyProduct-content-text">
                                <FormattedMessage id="modals.buy.description1" />{" "}
                                <strong></strong>{" "}
                                <FormattedMessage id="modals.buy.description2" />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            )}
        </div>
    );
};

export default AttoTrasferimentiModal;
